import React from 'react'

import PropTypes from 'prop-types'

import ConsentPromptLayout from '../ConsentPromptLayout'
import StandardConsentMessage from '../StandardConsentMessage'


export default function StandardConsentPrompt({ ariaLabel }) {
  return (
    <ConsentPromptLayout
      ariaLabel={ ariaLabel }
      messageComponent={ StandardConsentMessage }
    />
  )
}

StandardConsentPrompt.propTypes = {
  ariaLabel: PropTypes.string,
}
